export enum QUERY_FIELDS {
    Code = "code",
    Description = "description",
    Email = "email",
    IccId = "iccid",
    Id = "id",
    Imei = "imei",
    Name = "name",
    ProductCode = "product_code",
    Serial = "serial"
}
